import useAdmin from 'context/admin-context/hook';
import ClientsTableFillerRow from './ClientsTableRow/FillerRow';
import ClientsTableSimpleRow from './ClientsTableRow/SimpleRow';
import ClientsTableExpandableRow from './ClientsTableRow/ExpandableRow';

const ClientsTableBody = () => {
  const { state } = useAdmin();
  const { items } = state.clients;
  return (
   <tbody>
      {items.map(item => (item.purchases > 0
        ? <ClientsTableExpandableRow key={item.id} clientData={item} />
        : <ClientsTableSimpleRow key={item.id} clientData={item} />
      ))}
      <ClientsTableFillerRow />
    </tbody>
  );
};

export default ClientsTableBody;